import store from '@/store';

export async function setRequestPromise(id, promise) {
    return await store.dispatch('requests/setPromise', { id, promise });
}

export default setRequestPromise;
